import { analyticsFEA } from "src/AnalyticsFEA";
import { GarageKeyType } from "src/components/UserAccount/shared/GarageKey";
import { getFrom } from "../../../store/dataService/routes/shared/osfetch";

export const requestAccessCode = (requestType: GarageKeyType, account: string, garageKey: string) => {
    const cleanGarageKey = requestType === GarageKeyType.phone ? garageKey.replace(/[^0-9]/g, "") : garageKey;

    analyticsFEA.engine.signInStart();

    return getFrom(`/accounts/${account}/auth/${requestType}/${cleanGarageKey}`).then((response: Response) => {
        if (!response.ok) {
            throw new Error("Unable to request an access code");
        }
        return true;
    });
};
